import React from "react";
import NavBar from "../components/NavBar";

const FoodyCookiePage = ({ language, onLanguageChange, t }) => {
  const websiteCookies = t("foodyCookie.website.cookies") || [];

  return (
    <div className="page foody-page support-page" id="foody-cookie-top">
      <NavBar
        language={language}
        onLanguageChange={onLanguageChange}
        items={[
          { href: "/apps/foody", label: t("foodySupport.back") },
          {
            href: "/apps/foody/static/support",
            label: t("foodySupport.badge"),
          },
        ]}
      />

      <main className="foody-main">
        <section className="foody-hero support-hero">
          <div className="foody-hero-copy">
            <span className="support-pill">{t("foodyCookie.badge")}</span>
            <h1>{t("foodyCookie.hero.title")}</h1>
            <p>{t("foodyCookie.hero.desc")}</p>
          </div>
        </section>

        <section className="foody-section">
          <div className="foody-grid support-grid">
            <article className="foody-card">
              <h3>{t("foodyCookie.mobile.title")}</h3>
              <p>{t("foodyCookie.mobile.desc")}</p>
            </article>

            <article className="foody-card">
              <h3>{t("foodyCookie.website.title")}</h3>
              <p>{t("foodyCookie.website.desc")}</p>
              <ul className="support-list">
                {websiteCookies.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </article>

            <article className="foody-card">
              <h3>{t("foodyCookie.thirdParty.title")}</h3>
              <p>{t("foodyCookie.thirdParty.desc")}</p>
            </article>

            <article className="foody-card">
              <h3>{t("foodyCookie.manage.title")}</h3>
              <p>{t("foodyCookie.manage.desc")}</p>
            </article>
          </div>
        </section>

        <section className="foody-cta">
          <div>
            <h2>{t("foodyCookie.contact.title")}</h2>
            <p>
              {t("foodyCookie.contact.desc")}
              <br />
              <a href="mailto:support-foody@wodaslabs.com">
                support-foody@wodaslabs.com
              </a>
            </p>
          </div>
        </section>
      </main>
    </div>
  );
};

export default FoodyCookiePage;
